import { getEnvVariables } from "lib/environment";

export function initializeHeap() {
  const { heapKey: key, heapLocalstorage } = getEnvVariables();
  const storage = heapLocalstorage ? "localstorage" : "cookies";

  window.heap?.load?.(key, {
    disableTextCapture: true,
    enableSecureCookies: true,
    clearEventPropertiesOnNewUser: true,
    compressCookies: true,
    eventPropertiesStorage: storage,
    metadataStorage: storage,
  });
}
